import moment from 'moment'

export function writeGaEvent(v, category, action, userId, detail) {
  console.info(`TIME: ${moment().zone(0).format()}, BY: ${userId}, DETAIL: ${detail}`)
  v.$gtag.event(action, {
    'event_category': category,
    'event_label': `TIME: ${moment().zone(0).format()}, BY: ${userId}, DETAIL: ${detail}`
  })
}
